import type { AgentWidget } from 'aevocam-rest-api-spec'

/** Widgets that render a control or other visible chrome in the reply. */
export function widgetHasVisibleUi(widget: AgentWidget): boolean {
  switch (widget.type) {
    case 'refreshEditor':
      return false
    default:
      return true
  }
}
